import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class LogoutBehaviorService {

  private logoutState = new BehaviorSubject<boolean>(false);
  constructor() { }

  logout(): Observable<boolean> {
    return this.logoutState.asObservable();
  }

  setStatus(status: boolean): void {
    this.logoutState.next(status);
  }

  resetStatus(): void {
    this.logoutState.next(false);
  }

}
